var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.recipientType === "AR"
      ? _c(
          "div",
          _vm._l(_vm.principals, function(email, index) {
            return _c("div", [
              (_vm.timeEntry.invoiceId &&
                email.invoices !== null &&
                email.invoices.includes(_vm.timeEntry.invoiceId)) ||
              _vm.timeEntry.activityCode === _vm.$acConstants("EMAIL_REPORT")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "col-sm-2 control-label" }, [
                      _vm._v(_vm._s(email.email !== "adhoc" ? "To:" : "Cc:"))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-md-6" }, [
                      _c(
                        "div",
                        {
                          class: {
                            "input-group": email.companyType === "Insurer"
                          }
                        },
                        [
                          email.companyType === "Insurer"
                            ? _c("span", { staticClass: "input-group-addon" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.timeEntry.emailToCheckboxes,
                                      expression: "timeEntry.emailToCheckboxes"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    disabled:
                                      email.missingContact ||
                                      email.missingEmail ||
                                      _vm.timeEntry.isAuditEdit
                                  },
                                  domProps: {
                                    value: index,
                                    checked: Array.isArray(
                                      _vm.timeEntry.emailToCheckboxes
                                    )
                                      ? _vm._i(
                                          _vm.timeEntry.emailToCheckboxes,
                                          index
                                        ) > -1
                                      : _vm.timeEntry.emailToCheckboxes
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.timeEntry.emailToCheckboxes,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = index,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.timeEntry,
                                              "emailToCheckboxes",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.timeEntry,
                                              "emailToCheckboxes",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.timeEntry,
                                          "emailToCheckboxes",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          email.email !== "adhoc"
                            ? _c("span", [
                                _c("input", {
                                  staticClass: "form-control",
                                  class: {
                                    "invalid-state":
                                      email.missingContact || email.missingEmail
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: email.email !== "adhoc"
                                  },
                                  domProps: { value: _vm.getLabel(email) }
                                })
                              ])
                            : _c("span", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate.disable",
                                      value: "emails",
                                      expression: "'emails'",
                                      modifiers: { disable: true }
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.adhocEmail,
                                      expression: "adhocEmail"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    "data-vv-as": "adhoc Email",
                                    type: "text",
                                    id: "adhocEmail",
                                    name: "adhocEmail",
                                    placeholder:
                                      "Other email or list of emails separated by commas or semicolons",
                                    disabled: _vm.timeEntry.isAuditEdit
                                  },
                                  domProps: { value: _vm.adhocEmail },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.adhocEmail = $event.target.value
                                    }
                                  }
                                })
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("adhocEmail") && email.email === "adhoc"
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.errors.first("adhocEmail")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("emailTo") && email.email !== "adhoc"
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.errors.first("emailTo")))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    email.email !== "adhoc"
                      ? _c("div", { staticClass: "col-sm-1 email-to-action" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link",
                              attrs: { disabled: _vm.timeEntry.isAuditEdit },
                              on: {
                                click: function($event) {
                                  return _vm.pickContact(email.actionUrl)
                                }
                              }
                            },
                            [_vm._v(_vm._s(email.actionLabel))]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      : _vm.recipientType === "PR"
      ? _c(
          "div",
          _vm._l(_vm.principals, function(email, index) {
            return _c("div", [
              email.email !== "adhoc"
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "col-sm-2 control-label" }, [
                      _vm._v("To:")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-md-6" }, [
                      _c(
                        "div",
                        { class: { "input-group": _vm.principalCount > 1 } },
                        [
                          _vm.principalCount > 1
                            ? _c("span", { staticClass: "input-group-addon" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.timeEntry.emailToCheckboxes,
                                      expression: "timeEntry.emailToCheckboxes"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    disabled:
                                      email.missingContact ||
                                      email.missingEmail ||
                                      _vm.timeEntry.isAuditEdit
                                  },
                                  domProps: {
                                    value: index,
                                    checked: Array.isArray(
                                      _vm.timeEntry.emailToCheckboxes
                                    )
                                      ? _vm._i(
                                          _vm.timeEntry.emailToCheckboxes,
                                          index
                                        ) > -1
                                      : _vm.timeEntry.emailToCheckboxes
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.timeEntry.emailToCheckboxes,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = index,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.timeEntry,
                                              "emailToCheckboxes",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.timeEntry,
                                              "emailToCheckboxes",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.timeEntry,
                                          "emailToCheckboxes",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            class: {
                              "invalid-state":
                                email.missingContact || email.missingEmail
                            },
                            attrs: { type: "text", disabled: "disabled" },
                            domProps: { value: _vm.getLabel(email) }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("emailTo") &&
                      index == _vm.principalCount - 1
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.errors.first("emailTo")))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-1 email-to-action" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-link",
                          attrs: { disabled: _vm.timeEntry.isAuditEdit },
                          on: {
                            click: function($event) {
                              return _vm.pickContact(email.actionUrl)
                            }
                          }
                        },
                        [_vm._v(_vm._s(email.actionLabel))]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      : _vm.recipientType === "B"
      ? _c(
          "div",
          _vm._l(_vm.brokers, function(email, index) {
            return _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-sm-2 control-label" }, [
                _vm._v("To:")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8 col-md-6" }, [
                _c("input", {
                  staticClass: "form-control",
                  class: {
                    "invalid-state": email.missingContact || email.missingEmail
                  },
                  attrs: { type: "text", disabled: "disabled" },
                  domProps: { value: _vm.getLabel(email) }
                }),
                _vm._v(" "),
                _vm.errors.has("emailTo")
                  ? _c("p", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("emailTo")))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-1 email-to-action" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-link",
                    attrs: { disabled: _vm.timeEntry.isAuditEdit },
                    on: {
                      click: function($event) {
                        return _vm.pickContact(email.actionUrl)
                      }
                    }
                  },
                  [_vm._v(_vm._s(email.actionLabel))]
                )
              ])
            ])
          }),
          0
        )
      : _c(
          "div",
          {
            staticClass: "form-group",
            class: { "has-error": _vm.errors.has("emailTo") }
          },
          [
            _c(
              "label",
              {
                staticClass: "col-sm-2 control-label",
                attrs: { for: "emailTo" }
              },
              [_vm._v("To:")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8 col-md-6" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|email",
                    expression: "'required|email'",
                    modifiers: { disable: true }
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.timeEntry.emailTo,
                    expression: "timeEntry.emailTo"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  "data-vv-as": "to",
                  type: "text",
                  id: "emailTo",
                  name: "emailTo",
                  placeholder: "Who is this email to?",
                  disabled: _vm.timeEntry.isAuditEdit
                },
                domProps: { value: _vm.timeEntry.emailTo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.timeEntry, "emailTo", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("emailTo")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("emailTo")))
                  ])
                : _vm._e()
            ])
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3de96c", { render: render, staticRenderFns: staticRenderFns })
  }
}